import {IWuAppHeaderMenuItem} from '@/components/appHeader/types/WuAppHeaderMenuItem'
import {cn} from '@/lib/utils'

interface ICategoryDetailsProps {
  category: IWuAppHeaderMenuItem
  dir?: 'ltr' | 'rtl'
  openCategory?: IWuAppHeaderMenuItem | null
}

export const CategoryDetails: React.FC<ICategoryDetailsProps> = ({
  category,
  dir = 'ltr',
  openCategory,
}) => {
  const categoryBackground = category.active ? '#c5cce0' : '#f0c36a'
  const isOpenCategory = openCategory?.name === category.name

  const arrowIconClass = cn(
    'wm-arrow-forward-ios text-xs tracking-widest text-muted-foreground mr-2.5 group-hover:hidden text-blue-q',
    dir === 'rtl' && 'rotate-180 ml-2.5 text-blue-q group-hover:hidden',
    isOpenCategory && 'hidden',
    'relative top-[5px]',
  )
  const lockIconClass = cn(
    'wm-lock text-orange-soft text-base mr-2.5 group-hover:hidden',
    dir === 'rtl' && 'ml-2.5 group-hover:hidden',
    isOpenCategory && 'hidden',
    'relative top-1',
  )

  return (
    <div
      className="productCategoryDetails group focus:outline-none focus-visible:outline-none"
      dir={dir}
    >
      <div
        className="productCategoryBorderTop"
        style={{backgroundColor: categoryBackground}}
      />
      <div className="flex items-center px-1 relative top-1">
        <div className="productCategoryIcon">
          <img
            src={category.logo}
            alt={category.name}
            width="32px"
            height="32px"
          />
        </div>
        <span className="text-sm leading-5 text-blue-q relative top-[1px]">
          {category.name}
        </span>
      </div>

      {category.active ? (
        <span className={arrowIconClass}></span>
      ) : (
        <span className={lockIconClass}></span>
      )}
    </div>
  )
}
